import { api } from '@/config/api';

export interface PricingCatalog {
  _id: string;
  currency: string;
  baseMonthlyFee: number;

  pricePerWhatsappAccount: number;
  pricePerFacebookAccount: number;
  pricePerGoogleAdsAccount: number;
  pricePerTiktokAccount: number;
  pricePerEmailAccount: number;

  pricePerUser: number;

  pricePerContactBlock: number;
  contactBlockSize: number;

  pricePerMessageBlock: number;
  messageBlockSize: number;

  pricePerAiCreditBlock: number;
  aiCreditBlockSize: number;

  pricePerBotFlow: number;

  notes?: string;
}

export type UpsertCatalog = Partial<Omit<PricingCatalog, '_id'>>;

export interface QuoteCounts {
  whatsappAccounts?: number;
  facebookAccounts?: number;
  googleAdsAccounts?: number;
  tiktokAccounts?: number;
  emailAccounts?: number;
  users?: number;
  contacts?: number;
  messagesPerMonth?: number;
  aiCreditsPerMonth?: number;
  botFlows?: number;
}

export interface QuoteLineItem {
  resource: string;
  count: number;
  unit: string;
  unitPrice: number;
  subtotal: number;
}

export interface QuoteResult {
  currency: string;
  baseMonthlyFee: number;
  lineItems: QuoteLineItem[];
  total: number;
}

export const pricingService = {
  get:    async (): Promise<PricingCatalog> => (await api.get('/super_admin/pricing')).data,
  update: async (p: UpsertCatalog): Promise<PricingCatalog> => (await api.patch('/super_admin/pricing', p)).data,
  quote:  async (counts: QuoteCounts): Promise<QuoteResult> => (await api.post('/super_admin/pricing/quote', counts)).data,
};
